module.exports = __webpack_public_path__ + "static/media/pencil-stroke.4d7f3542.svg";